
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Picker from 'vux/src/components/picker/index.vue'

import DateFormatter from '../../../tools/dateFormatter'
export default{
components: {
PopupPicker,
Popup,
Picker
},
directives: {
TransferDom
},
props: {
defaultSelectIndex: Number,
bankIconList: Array,
bankList: Array
},
data() {
return {
show: false,
innerBankList: [],
bankInfo: [],
selectBank: [],
selectBankName: ''
}
},
methods: {
pickerSureBtnClick() {
this.$emit('onClickSureBtn', this.selectBank[0])
this.show = false
},
change(value) {
this.selectBankName = this.bankList[parseInt(value[0])]
}
},
watch: {
show: function (val, oldVal) {
if (val) {
let tempArr = [];
for (let i = 0, length = this.bankList.length; i < length; i++) {
let value = this.bankList[i];
let bankIcon = this.bankIconList[i];
let name = '<img src=' + '"' + bankIcon + '"' + 'class="bank-icon">' + value
tempArr.push({
name: name,
value: i
})
}
this.innerBankList = [tempArr]
this.selectBank = [this.innerBankList[0][this.defaultSelectIndex]['value']]
this.selectBankName = this.bankList[this.defaultSelectIndex]
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/views/common/xy-bank-picker.vue